import React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from '../../../reducers/index';

import Navigation from '../../Navigation';
import Footer from '../../Footer';
import ImageHero from '../../ImageBanner';
import ProgressBar from '../../ProgressBar';

const EducationModuleLayout = props => {
  const { progressStage, progressType, children, childTitle } = props;

  return (
    <div className={`${progressType}-module`}>
      <Helmet>
        <title>{`Education Module - ${childTitle}`}</title>
      </Helmet>
      <Navigation role={props.role} />
      <ImageHero childTitle={childTitle} />
      <section>
        <div id="maincontent" className="container intro">
          <ProgressBar progressStage={progressStage} type={progressType} />
        </div>
      </section>
      {children}
      <Footer />
    </div>
  );
};

export default connect.role(EducationModuleLayout);



// WEBPACK FOOTER //
// ./src/components/Layout/EducationModuleLayout/index.jsx